var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_22785)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_22785",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H48V48H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_22785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.125 33.2187H38.8437C35.7371 33.2187 33.2187 35.7371 33.2187 38.8437V46.125M46.125 33.2187C46.125 35.5799 45.187 37.8443 43.5175 39.5137L39.5137 43.5175C37.8442 45.187 35.5799 46.125 33.2187 46.125M46.125 33.2187V11.2641C46.125 8.77397 45.1357 6.38579 43.375 4.62497C41.6142 2.86425 39.226 1.875 36.7359 1.875H11.2641C8.77397 1.875 6.38578 2.86425 4.62497 4.62497C2.86425 6.38579 1.875 8.77397 1.875 11.2641V36.7359C1.875 39.226 2.86425 41.6142 4.62497 43.375C6.38578 45.1357 8.77397 46.125 11.2641 46.125H31.375H33.2187M12.9375 35.0625H24M12.9375 12.9375H35.0625M12.9375 24H35.0625",
    stroke: "#083342",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_22785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/ic-file.c7023659aadd58c7d2384507e8849df0.svg";
export { ForwardRef as ReactComponent };